import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"

export default class extends Controller {
  static targets = [
    "permissionDefault",
    "permissionGranted",
    "permissionDenied",
    "unsupported"
  ]

  connect() {
    if (this.notificationsSupported) {
      if (Notification.permission == "default") {
        this.permissionDefaultTarget.hidden = false
      } else if (Notification.permission == "granted") {
        this.permissionGrantedTarget.hidden = false
      } else if (Notification.permission == "denied") {
        this.permissionDeniedTarget.hidden = false
      }
    } else {
      this.unsupportedTarget.hidden = false
    }
  }

  async attemptToSubscribe() {
    const registration = await this.getServiceWorkerRegistration() || await this.registerServiceWorker()
    const permission = await Notification.requestPermission()

    if (permission === "granted") {
      this.subscribe(registration)
    } else {
      this.permissionDefaultTarget.hidden = true
      this.permissionDeniedTarget.hidden = false
    }
  }

  async subscribe(registration) {
    registration.pushManager.subscribe({
      userVisibleOnly: true, applicationServerKey: this.vapidPublicKey
    })
    .then(subscription => {
      this.createPushSubscription(subscription)
    })
  }

  async createPushSubscription(subscription) {
    const subscriptionJson = subscription.toJSON()

    const payload = {
      endpoint: subscriptionJson.endpoint,
      p256dh_key: subscriptionJson.keys.p256dh,
      auth_key: subscriptionJson.keys.auth
    }
    const response = await post("/my/push_subscriptions", {body: payload})

    if (response.ok) {
      this.permissionDefaultTarget.hidden = true
      this.permissionGrantedTarget.hidden = false
    } else {
      subscription.unsubscribe()
    }
  }

  async getServiceWorkerRegistration() {
    return navigator.serviceWorker.getRegistration("/service-worker.js", {scope: "/"})
  }

  registerServiceWorker() {
    return navigator.serviceWorker.register("/service-worker.js", {scope: "/"})
  }

  get vapidPublicKey() {
    return document.querySelector('meta[name="vapid-public-key"]').content
  }

  get notificationsSupported() {
    return navigator.serviceWorker && window.Notification
  }
}
